import React from 'react'
import styleModules from './TextEditor.module.scss'
import Field from './Field'
import { StyledTextEditor } from './styled'

const TextEditor = ({ label, ...props }) => {
	return(
		<StyledTextEditor className={styleModules.root}>
			{ label ? <p>{label}</p> : null }
			<Field {...props}/>
		</StyledTextEditor>
	)
}


export default TextEditor
